/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PerpetualPair {
  id?: number;
  symbol?: string;
  exchangeName?: PerpetualPair.ExchangeNameEnum;
  baseAssetId?: number;
  quoteAssetId?: number;
  qtyScale?: number;
  priceScale?: number;
}
export namespace PerpetualPair {
  export const ExchangeNameEnum = {
    BinanceSpot: 'BINANCE_SPOT',
    BinancePerpetual: 'BINANCE_PERPETUAL',
    BybitSpot: 'BYBIT_SPOT',
    BybitPerpetual: 'BYBIT_PERPETUAL',
    OkxSpot: 'OKX_SPOT',
    OkxPerpetual: 'OKX_PERPETUAL',
    Aggregate: 'AGGREGATE',
    Multiply: 'MULTIPLY',
    Divide: 'DIVIDE',
    PerpSpotChaining: 'PERP_SPOT_CHAINING',
    LiquidityProvider: 'LIQUIDITY_PROVIDER',
    CoinbasePerpetual: 'COINBASE_PERPETUAL',
    KrakenSpot: 'KRAKEN_SPOT',
    CoinbaseSpot: 'COINBASE_SPOT',
  } as const;
  export type ExchangeNameEnum = (typeof ExchangeNameEnum)[keyof typeof ExchangeNameEnum];
}
